/*eslint-disable */
const $ = window.jQuery = require('jquery');
import {mapGetters} from 'vuex';
import {
  bus
} from '@/main';
export default {
  name: 'error-storage-full',
  components: {},
  props: [],
  data () {
    return {
      selfUserInfo:null
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters'
    ]),
    getSelfUserInfoFun(){
      this.selfUserInfo = this.$store.getters.acUserDetailsStateGetters.data
      return
    },
  },
  mounted () {
    this.getSelfUserInfoFun
  },
  methods: {
    closePopupOfErrorSpaceFullFun(){
      bus.$emit('errorStorageFullStateBus', false)
      $('body').removeClass('body_right_scroll_remove')
    },
  },
  watch:{
    getSelfUserInfoFun(){
      return this.$store.getters.acUserDetailsStateGetters
    },
  }
}